<script>
  export default {
    props: ['data'],
  }
</script>

<template>
  <div>
    <table class="table table-striped table-bordered f12">
      <thead>
        <tr class="bg-head1">
          <th style="width: 50px"><b>STT</b></th>
          <th><b>Loại thẻ/Phương thức thanh toán</b></th>
          <th class="txt-center"><b>Mức phí</b></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <td class="txt-center">{{ index + 1 }}</td>
          <td>{{ item.bankName }}</td>
          <td class="txt-center">
            <span class="bg-yellow">
              <b>{{ item.percentageFee }} %</b>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
